import { CompetitorData } from "../DataProvider";
import { PodiumCard } from "./PodiumCard";

interface PodiumProps {
  competitors: CompetitorData[];
  compact?: boolean;
}

export function Podium({ competitors, compact = false }: PodiumProps) {
  const first = competitors.find((c) => c.arrival === 1) ?? null;
  const second = competitors.find((c) => c.arrival === 2) ?? null;
  const third = competitors.find((c) => c.arrival === 3) ?? null;

  return (
    <div className={`flex w-full h-full ${compact ? 'gap-2' : 'gap-8'}`}>
      <PodiumCard competitor={second} compact={compact} />
      <PodiumCard competitor={first} compact={compact} />
      <PodiumCard competitor={third} compact={compact} />
    </div>
  );
}